import Kids from "../../../entities/Kids/ui/Kids";

const KidsPage = () => {
    return ( 
        <main>
            <Kids/>
        </main>
     );
}
 
export default KidsPage;